/**
 * sets ARTICLE container height so without content it has at least the height required to force FOOTER to be on the bottom of the screen viewport not right bellow latest article with grey backgound covering the rest of the PAGE
 */

export function articleContainerHeight() {

    // inner window height - our reference point
    let windowHeight = window.innerHeight;
    let articleContainer = document.getElementById("articleContainer");
        
    let footer = document.getElementById("footer");
    let totalHeight = 0;
    if (footer !== null && articleContainer !== null)
    {
        //console.log("windowHeight" + windowHeight);
        //console.log("footerHeight" + footer.offsetHeight);
        totalHeight = footer.offsetHeight * 0.8;
        articleContainer.style.minHeight = String((windowHeight - totalHeight) * 1.25) + "px";
    }
}